import { InlineMessage, TextLink } from '@pm/ui';
import * as Sentry from '@sentry/react';
import { Trans, useTranslation } from 'react-i18next';

export const LabError = ({
  error,
  supportLink,
}: {
  error: Error;
  supportLink: string;
}) => {
  const { t } = useTranslation('global');

  Sentry.captureException(
    new Error(`Error loading lab work: ${error.message}`),
  );

  return (
    <InlineMessage
      intent="error"
      title={t('Errors.Generic.Title')}
      instructions={
        <Trans t={t} i18nKey="Errors.ContactSupport.Instructions">
          <TextLink to={supportLink} external />
        </Trans>
      }
    />
  );
};
